import { z } from 'zod';

export const staffRoleSchema = z.enum([
  "doctor", "nurse", "pharmacist", "lab_tech",
  "reception", "billing", "cleaner", "security", "admin", "other"
]);

export const staffStatusSchema = z.enum([
  "active", "inactive", "resigned", "terminated"
]);

export const staffSchema = z.object({
  id: z.string().optional(),
  empCode: z.string().optional(), // auto-generated
  role: staffRoleSchema,
  department: z.string().optional(),
  status: staffStatusSchema,

  name: z.string().min(1, "Name is required"),
  gender: z.enum(["male", "female", "other"]).optional(),
  dob: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().email().optional().or(z.literal("")),
  address: z.string().optional(),
  photoUrl: z.string().optional(),
  nidOrPassport: z.string().optional(),
  bloodGroup: z.string().optional(),

  qualification: z.string().optional(),
  licenseNo: z.string().optional(),
  specialization: z.string().optional(),
  experienceYears: z.number().min(0).optional(),

  salary: z.number().min(0).optional(),
  bankAccount: z.string().optional(),
  taxId: z.string().optional(),

  userId: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),

  qrCodeUrl: z.string().optional(),
  cardIssuedAt: z.string().optional(),
});

export type StaffFormData = z.infer<typeof staffSchema>;
